module.exports = {
	"classes": [
		"trust-page",
		"header-dark"
	],
	"title": "Availability & Trust",
	"metas": {
		"description": "At Auth0, availability and reliability are our priority. Making Auth0 resilient to failures (that happen all the time) is a continuous task for our engineering team."
	},
	"opengraph": {},
	"twittercard": {}
};


//////////////////
// WEBPACK FOOTER
// ./src/pages/availability-trust/metadata.json
// module id = 1107
// module chunks = 0